export default __webpack_public_path__ + "static/media/Zeki.c1b64fc5.webp";